import { render, staticRenderFns } from "./financialmanagement.vue?vue&type=template&id=31942334&scoped=true&"
import script from "./financialmanagement.vue?vue&type=script&lang=js&"
export * from "./financialmanagement.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=31942334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31942334",
  null
  
)

export default component.exports